var city = {
  citycode: [],
  adcode: "320000",
  name: "江苏省",
  center: {
    lng: 118.763563,
    lat: 32.061377
  },
  districtList: [
    {
      citycode: "0518",
      adcode: "320700",
      name: "连云港市",
      center: {
        lng: 119.221487,
        lat: 34.596639
      },
      districtList: [
        {
          citycode: "0518",
          adcode: "320724",
          name: "灌南县",
          center: {
            lng: 119.315583,
            lat: 34.087251
          }
        },
        {
          citycode: "0518",
          adcode: "320707",
          name: "赣榆区",
          center: {
            lng: 119.173173,
            lat: 34.841336
          }
        },
        {
          citycode: "0518",
          adcode: "320703",
          name: "连云区",
          center: {
            lng: 119.338901,
            lat: 34.760317
          }
        },
        {
          citycode: "0518",
          adcode: "320723",
          name: "灌云县",
          center: {
            lng: 119.239426,
            lat: 34.284074
          }
        },
        {
          citycode: "0518",
          adcode: "320706",
          name: "海州区",
          center: {
            lng: 119.163492,
            lat: 34.572506
          }
        },
        {
          citycode: "0518",
          adcode: "320722",
          name: "东海县",
          center: {
            lng: 118.752869,
            lat: 34.542194
          }
        }
      ]
    },
    {
      citycode: "0513",
      adcode: "320600",
      name: "南通市",
      center: {
        lng: 120.894522,
        lat: 31.981269
      },
      districtList: [
        {
          citycode: "0513",
          adcode: "320623",
          name: "如东县",
          center: {
            lng: 121.18495,
            lat: 32.331584
          }
        },
        {
          citycode: "0513",
          adcode: "320613",
          name: "崇川区",
          center: {
            lng: 120.857253,
            lat: 32.010277
          }
        },
        {
          citycode: "0513",
          adcode: "320681",
          name: "启东市",
          center: {
            lng: 121.65523,
            lat: 31.792831
          }
        },
        {
          citycode: "0513",
          adcode: "320612",
          name: "通州区",
          center: {
            lng: 121.073742,
            lat: 32.065972
          }
        },
        {
          citycode: "0513",
          adcode: "320614",
          name: "海门区",
          center: {
            lng: 121.182016,
            lat: 31.869418
          }
        },
        {
          citycode: "0513",
          adcode: "320682",
          name: "如皋市",
          center: {
            lng: 120.574028,
            lat: 32.371493
          }
        },
        {
          citycode: "0513",
          adcode: "320685",
          name: "海安市",
          center: {
            lng: 120.46779,
            lat: 32.532853
          }
        }
      ]
    },
    {
      citycode: "0527",
      adcode: "321300",
      name: "宿迁市",
      center: {
        lng: 118.275228,
        lat: 33.963186
      },
      districtList: [
        {
          citycode: "0527",
          adcode: "321323",
          name: "泗阳县",
          center: {
            lng: 118.703636,
            lat: 33.723576
          }
        },
        {
          citycode: "0527",
          adcode: "321324",
          name: "泗洪县",
          center: {
            lng: 118.223941,
            lat: 33.476575
          }
        },
        {
          citycode: "0527",
          adcode: "321311",
          name: "宿豫区",
          center: {
            lng: 118.330423,
            lat: 33.94813
          }
        },
        {
          citycode: "0527",
          adcode: "321302",
          name: "宿城区",
          center: {
            lng: 118.242048,
            lat: 33.963891
          }
        },
        {
          citycode: "0527",
          adcode: "321322",
          name: "沭阳县",
          center: {
            lng: 118.804321,
            lat: 34.110642
          }
        }
      ]
    },
    {
      citycode: "0517",
      adcode: "320800",
      name: "淮安市",
      center: {
        lng: 119.113166,
        lat: 33.551495
      },
      districtList: [
        {
          citycode: "0517",
          adcode: "320804",
          name: "淮阴区",
          center: {
            lng: 119.034895,
            lat: 33.632588
          }
        },
        {
          citycode: "0517",
          adcode: "320830",
          name: "盱眙县",
          center: {
            lng: 118.544545,
            lat: 33.011905
          }
        },
        {
          citycode: "0517",
          adcode: "320826",
          name: "涟水县",
          center: {
            lng: 119.260589,
            lat: 33.781648
          }
        },
        {
          citycode: "0517",
          adcode: "320831",
          name: "金湖县",
          center: {
            lng: 119.020432,
            lat: 33.024663
          }
        },
        {
          citycode: "0517",
          adcode: "320813",
          name: "洪泽区",
          center: {
            lng: 118.873132,
            lat: 33.294095
          }
        },
        {
          citycode: "0517",
          adcode: "320812",
          name: "清江浦区",
          center: {
            lng: 119.026662,
            lat: 33.552579
          }
        },
        {
          citycode: "0517",
          adcode: "320803",
          name: "淮安区",
          center: {
            lng: 119.141183,
            lat: 33.50296
          }
        }
      ]
    },
    {
      citycode: "0511",
      adcode: "321100",
      name: "镇江市",
      center: {
        lng: 119.424441,
        lat: 32.188141
      },
      districtList: [
        {
          citycode: "0511",
          adcode: "321182",
          name: "扬中市",
          center: {
            lng: 119.796816,
            lat: 32.236476
          }
        },
        {
          citycode: "0511",
          adcode: "321111",
          name: "润州区",
          center: {
            lng: 119.411383,
            lat: 32.195146
          }
        },
        {
          citycode: "0511",
          adcode: "321112",
          name: "丹徒区",
          center: {
            lng: 119.433854,
            lat: 32.132118
          }
        },
        {
          citycode: "0511",
          adcode: "321183",
          name: "句容市",
          center: {
            lng: 119.168693,
            lat: 31.945732
          }
        },
        {
          citycode: "0511",
          adcode: "321181",
          name: "丹阳市",
          center: {
            lng: 119.606071,
            lat: 32.010035
          }
        },
        {
          citycode: "0511",
          adcode: "321102",
          name: "京口区",
          center: {
            lng: 119.470186,
            lat: 32.198285
          }
        }
      ]
    },
    {
      citycode: "025",
      adcode: "320100",
      name: "南京市",
      center: {
        lng: 118.796624,
        lat: 32.059344
      },
      districtList: [
        {
          citycode: "025",
          adcode: "320114",
          name: "雨花台区",
          center: {
            lng: 118.779087,
            lat: 31.991291
          }
        },
        {
          citycode: "025",
          adcode: "320115",
          name: "江宁区",
          center: {
            lng: 118.83951,
            lat: 31.953195
          }
        },
        {
          citycode: "025",
          adcode: "320118",
          name: "高淳区",
          center: {
            lng: 118.892074,
            lat: 31.328678
          }
        },
        {
          citycode: "025",
          adcode: "320117",
          name: "溧水区",
          center: {
            lng: 119.028414,
            lat: 31.651108
          }
        },
        {
          citycode: "025",
          adcode: "320105",
          name: "建邺区",
          center: {
            lng: 118.731642,
            lat: 32.003343
          }
        },
        {
          citycode: "025",
          adcode: "320116",
          name: "六合区",
          center: {
            lng: 118.822241,
            lat: 32.323235
          }
        },
        {
          citycode: "025",
          adcode: "320106",
          name: "鼓楼区",
          center: {
            lng: 118.769943,
            lat: 32.066814
          }
        },
        {
          citycode: "025",
          adcode: "320104",
          name: "秦淮区",
          center: {
            lng: 118.794792,
            lat: 32.039065
          }
        },
        {
          citycode: "025",
          adcode: "320111",
          name: "浦口区",
          center: {
            lng: 118.627165,
            lat: 32.059796
          }
        },
        {
          citycode: "025",
          adcode: "320102",
          name: "玄武区",
          center: {
            lng: 118.797779,
            lat: 32.048644
          }
        },
        {
          citycode: "025",
          adcode: "320113",
          name: "栖霞区",
          center: {
            lng: 118.909117,
            lat: 32.096423
          }
        }
      ]
    },
    {
      citycode: "0515",
      adcode: "320900",
      name: "盐城市",
      center: {
        lng: 120.16263,
        lat: 33.348176
      },
      districtList: [
        {
          citycode: "0515",
          adcode: "320924",
          name: "射阳县",
          center: {
            lng: 120.326338,
            lat: 33.766277
          }
        },
        {
          citycode: "0515",
          adcode: "320922",
          name: "滨海县",
          center: {
            lng: 119.820713,
            lat: 33.990372
          }
        },
        {
          citycode: "0515",
          adcode: "320921",
          name: "响水县",
          center: {
            lng: 119.578332,
            lat: 34.199172
          }
        },
        {
          citycode: "0515",
          adcode: "320981",
          name: "东台市",
          center: {
            lng: 120.320308,
            lat: 32.867845
          }
        },
        {
          citycode: "0515",
          adcode: "320925",
          name: "建湖县",
          center: {
            lng: 119.788743,
            lat: 33.438931
          }
        },
        {
          citycode: "0515",
          adcode: "320923",
          name: "阜宁县",
          center: {
            lng: 119.802271,
            lat: 33.758857
          }
        },
        {
          citycode: "0515",
          adcode: "320903",
          name: "盐都区",
          center: {
            lng: 120.153567,
            lat: 33.338538
          }
        },
        {
          citycode: "0515",
          adcode: "320904",
          name: "大丰区",
          center: {
            lng: 120.500761,
            lat: 33.200047
          }
        },
        {
          citycode: "0515",
          adcode: "320902",
          name: "亭湖区",
          center: {
            lng: 120.196148,
            lat: 33.391414
          }
        }
      ]
    },
    {
      citycode: "0519",
      adcode: "320400",
      name: "常州市",
      center: {
        lng: 119.974092,
        lat: 31.811313
      },
      districtList: [
        {
          citycode: "0519",
          adcode: "320413",
          name: "金坛区",
          center: {
            lng: 119.587503,
            lat: 31.722384
          }
        },
        {
          citycode: "0519",
          adcode: "320481",
          name: "溧阳市",
          center: {
            lng: 119.484164,
            lat: 31.416967
          }
        },
        {
          citycode: "0519",
          adcode: "320411",
          name: "新北区",
          center: {
            lng: 119.960925,
            lat: 31.86355
          }
        },
        {
          citycode: "0519",
          adcode: "320404",
          name: "钟楼区",
          center: {
            lng: 119.902081,
            lat: 31.802608
          }
        },
        {
          citycode: "0519",
          adcode: "320412",
          name: "武进区",
          center: {
            lng: 119.942441,
            lat: 31.701252
          }
        },
        {
          citycode: "0519",
          adcode: "320402",
          name: "天宁区",
          center: {
            lng: 119.999439,
            lat: 31.79232
          }
        }
      ]
    },
    {
      citycode: "0523",
      adcode: "321200",
      name: "泰州市",
      center: {
        lng: 119.922883,
        lat: 32.456692
      },
      districtList: [
        {
          citycode: "0523",
          adcode: "321202",
          name: "海陵区",
          center: {
            lng: 119.923825,
            lat: 32.49248
          }
        },
        {
          citycode: "0523",
          adcode: "321282",
          name: "靖江市",
          center: {
            lng: 120.277124,
            lat: 31.98325
          }
        },
        {
          citycode: "0523",
          adcode: "321204",
          name: "姜堰区",
          center: {
            lng: 120.12807,
            lat: 32.51029
          }
        },
        {
          citycode: "0523",
          adcode: "321283",
          name: "泰兴市",
          center: {
            lng: 120.051475,
            lat: 32.173072
          }
        },
        {
          citycode: "0523",
          adcode: "321203",
          name: "高港区",
          center: {
            lng: 119.88154,
            lat: 32.31923
          }
        },
        {
          citycode: "0523",
          adcode: "321281",
          name: "兴化市",
          center: {
            lng: 119.85255,
            lat: 32.911952
          }
        }
      ]
    },
    {
      citycode: "0514",
      adcode: "321000",
      name: "扬州市",
      center: {
        lng: 119.412834,
        lat: 32.394404
      },
      districtList: [
        {
          citycode: "0514",
          adcode: "321002",
          name: "广陵区",
          center: {
            lng: 119.431785,
            lat: 32.395654
          }
        },
        {
          citycode: "0514",
          adcode: "321081",
          name: "仪征市",
          center: {
            lng: 119.184468,
            lat: 32.272833
          }
        },
        {
          citycode: "0514",
          adcode: "321003",
          name: "邗江区",
          center: {
            lng: 119.397935,
            lat: 32.37741
          }
        },
        {
          citycode: "0514",
          adcode: "321012",
          name: "江都区",
          center: {
            lng: 119.569684,
            lat: 32.43571
          }
        },
        {
          citycode: "0514",
          adcode: "321023",
          name: "宝应县",
          center: {
            lng: 119.358389,
            lat: 33.241125
          }
        },
        {
          citycode: "0514",
          adcode: "321084",
          name: "高邮市",
          center: {
            lng: 119.45892,
            lat: 32.781606
          }
        }
      ]
    },
    {
      citycode: "0516",
      adcode: "320300",
      name: "徐州市",
      center: {
        lng: 117.283752,
        lat: 34.204224
      },
      districtList: [
        {
          citycode: "0516",
          adcode: "320305",
          name: "贾汪区",
          center: {
            lng: 117.465137,
            lat: 34.436492
          }
        },
        {
          citycode: "0516",
          adcode: "320312",
          name: "铜山区",
          center: {
            lng: 117.169698,
            lat: 34.181162
          }
        },
        {
          citycode: "0516",
          adcode: "320311",
          name: "泉山区",
          center: {
            lng: 117.194405,
            lat: 34.22655
          }
        },
        {
          citycode: "0516",
          adcode: "320302",
          name: "鼓楼区",
          center: {
            lng: 117.185643,
            lat: 34.288736
          }
        },
        {
          citycode: "0516",
          adcode: "320303",
          name: "云龙区",
          center: {
            lng: 117.251515,
            lat: 34.253638
          }
        },
        {
          citycode: "0516",
          adcode: "320322",
          name: "沛县",
          center: {
            lng: 116.936353,
            lat: 34.760761
          }
        },
        {
          citycode: "0516",
          adcode: "320321",
          name: "丰县",
          center: {
            lng: 116.658111,
            lat: 34.697232
          }
        },
        {
          citycode: "0516",
          adcode: "320381",
          name: "新沂市",
          center: {
            lng: 118.354747,
            lat: 34.369585
          }
        },
        {
          citycode: "0516",
          adcode: "320324",
          name: "睢宁县",
          center: {
            lng: 117.941364,
            lat: 33.913727
          }
        },
        {
          citycode: "0516",
          adcode: "320382",
          name: "邳州市",
          center: {
            lng: 118.012511,
            lat: 34.339208
          }
        }
      ]
    },
    {
      citycode: "0510",
      adcode: "320200",
      name: "无锡市",
      center: {
        lng: 120.311889,
        lat: 31.491064
      },
      districtList: [
        {
          citycode: "0510",
          adcode: "320282",
          name: "宜兴市",
          center: {
            lng: 119.821873,
            lat: 31.338429
          }
        },
        {
          citycode: "0510",
          adcode: "320281",
          name: "江阴市",
          center: {
            lng: 120.284794,
            lat: 31.921642
          }
        },
        {
          citycode: "0510",
          adcode: "320205",
          name: "锡山区",
          center: {
            lng: 120.357732,
            lat: 31.589484
          }
        },
        {
          citycode: "0510",
          adcode: "320211",
          name: "滨湖区",
          center: {
            lng: 120.284381,
            lat: 31.527846
          }
        },
        {
          citycode: "0510",
          adcode: "320206",
          name: "惠山区",
          center: {
            lng: 120.29843,
            lat: 31.680282
          }
        },
        {
          citycode: "0510",
          adcode: "320214",
          name: "新吴区",
          center: {
            lng: 120.364303,
            lat: 31.49085
          }
        },
        {
          citycode: "0510",
          adcode: "320213",
          name: "梁溪区",
          center: {
            lng: 120.303551,
            lat: 31.566226
          }
        }
      ]
    },
    {
      citycode: "0512",
      adcode: "320500",
      name: "苏州市",
      center: {
        lng: 120.585294,
        lat: 31.299758
      },
      districtList: [
        {
          citycode: "0512",
          adcode: "320505",
          name: "虎丘区",
          center: {
            lng: 120.434238,
            lat: 31.329601
          }
        },
        {
          citycode: "0512",
          adcode: "320585",
          name: "太仓市",
          center: {
            lng: 121.130344,
            lat: 31.458043
          }
        },
        {
          citycode: "0512",
          adcode: "320507",
          name: "相城区",
          center: {
            lng: 120.642391,
            lat: 31.369189
          }
        },
        {
          citycode: "0512",
          adcode: "320509",
          name: "吴江区",
          center: {
            lng: 120.645728,
            lat: 31.138525
          }
        },
        {
          citycode: "0512",
          adcode: "320508",
          name: "姑苏区",
          center: {
            lng: 120.617367,
            lat: 31.335648
          }
        },
        {
          citycode: "0512",
          adcode: "320581",
          name: "常熟市",
          center: {
            lng: 120.752512,
            lat: 31.656016
          }
        },
        {
          citycode: "0512",
          adcode: "320582",
          name: "张家港市",
          center: {
            lng: 120.555979,
            lat: 31.876739
          }
        },
        {
          citycode: "0512",
          adcode: "320583",
          name: "昆山市",
          center: {
            lng: 120.980795,
            lat: 31.385476
          }
        },
        {
          citycode: "0512",
          adcode: "320506",
          name: "吴中区",
          center: {
            lng: 120.632094,
            lat: 31.263604
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/jiangsu.js